function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 18.8A4.8 4.8 0 018.8 14h6.4a4.8 4.8 0 014.8 4.8v0a3.2 3.2 0 01-3.2 3.2H7.2A3.2 3.2 0 014 18.8v0zM16 6a4 4 0 11-8 0 4 4 0 018 0z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    stroke: "#2F384C",
    fill: "none"
  }, props), _ref);
};

export default SvgAvatar;